import { render, staticRenderFns } from "./BlockedReport.vue?vue&type=template&id=31c7cdb5&scoped=true&"
import script from "./BlockedReport.vue?vue&type=script&lang=js&"
export * from "./BlockedReport.vue?vue&type=script&lang=js&"
import style0 from "./BlockedReport.vue?vue&type=style&index=0&id=31c7cdb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c7cdb5",
  null
  
)

export default component.exports